import React from "react";
import styles from "../_css/propertyCardPriceValue.module.css";
import { calculateAndFormatPropertyPrice } from "_common/_utils/propertyUtils";
import { NoSsr } from "@material-ui/core";
import { useCurrency } from "_common/currency/CurrencyProvider";
import { useTranslation } from "react-i18next";
import { PROPERTY_TABS } from "properties/propertyPage/PropertyContent";
import { useHistory, useLocation } from "react-router-dom";
import { usePropertyTabs } from "properties/propertyPage/PropertyTabsProvider";

type Props = {
    priceMin: number;
    priceInPesosMin: number;
    isInPesosProperty: boolean;
    isNotFrom?: boolean;
    isProperty?: boolean;
    textSize?: string;
};

export function PropertyCardPriceValue({
    priceMin,
    priceInPesosMin,
    isInPesosProperty,
    isNotFrom,
    isProperty,
    textSize,
}: Props) {
    const { currentCurrency } = useCurrency();
    const { t } = useTranslation();
    const priceForCalculate = {
        priceMin: priceMin,
        priceInPesosMin: priceInPesosMin,
        priceIsInPesos: isInPesosProperty,
    };
    const price = calculateAndFormatPropertyPrice(priceForCalculate, currentCurrency);
    const history = useHistory();
    const location = useLocation();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const setPropertyTabs = isProperty ? usePropertyTabs().setPropertyTabs : null;

    if (!price) return null;
    return (
        <NoSsr>
            {!isNotFrom && t("words.from")}
            <div className={`${styles.container} ${textSize}`}>{price}</div>
            {isProperty && (
                <div
                    onClick={() => {
                        if (setPropertyTabs) {
                            setPropertyTabs(PROPERTY_TABS.INVENTORY);
                        }
                        history.push({
                            pathname: location.pathname,
                            search: `?propertyTab=${PROPERTY_TABS.INVENTORY}`,
                        });
                    }}
                    className={"ml-3 text-[#299ac3] hover:underline cursor-pointer hidden sm:block"}
                >
                    {t("propertyPage.viewsPricesDetails")}
                </div>
            )}
        </NoSsr>
    );
}
